import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon-2x.png';
import icon2x from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { useEffect } from 'react';
import { MapContainer, Marker, Popup, TileLayer, useMap } from 'react-leaflet';

const DefaultIcon = L.icon({
    iconUrl: icon2x,
    iconRetinaUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
});

L.Marker.prototype.options.icon = DefaultIcon;

type LocationMapProps = {
    latitude: number;
    longitude: number;
    address?: string;
};

function MapUpdater({ latitude, longitude }: { latitude: number; longitude: number }) {
    const map = useMap();

    useEffect(() => {
        map.setView([latitude, longitude], 15);
    }, [latitude, longitude, map]);

    return null;
}

export function LocationMap({ latitude, longitude, address }: LocationMapProps) {
    useEffect(() => {
        // Invalidate size when component mounts to fix tile loading issues
        const timeoutId = setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100);

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div className="w-full h-[300px] rounded-lg overflow-hidden border relative z-0">
            <MapContainer
                center={[latitude, longitude]}
                zoom={15}
                scrollWheelZoom={false}
                style={{ height: '100%', width: '100%' }}
            >
                <MapUpdater latitude={latitude} longitude={longitude} />
                <TileLayer
                    attribution='&copy; <a href="https://carto.com/attributions">CARTO</a>'
                    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
                />
                <Marker position={[latitude, longitude]}>
                    {address && (
                        <Popup>
                            {address}
                        </Popup>
                    )}
                </Marker>
            </MapContainer>
        </div>
    );
}
